export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";